/**
 * B1 / AP-5 (P13) — „Archiv" & „Papierkorb" als eigene „Dateien"-Unterpunkte.
 * Frontend-only: die Rollen-Ordner existieren bereits (Migration 012 je WS,
 * Migration 039 je Gruppe, D-132). Diese Ansicht löst den Rollen-Ordner des
 * AKTIVEN Scopes auf (Gruppe, falls eine aktiv ist — sonst Workspace) und rendert
 * die gewohnte Datei-Tabelle darin; deren in_role-Logik zeigt automatisch
 * Wiederherstellen / endgültig löschen.
 *
 * Der Scope-Bezug (Gruppe vs. WS) dockt damit direkt an den Scope-Switcher an —
 * wechselt der aktive Scope, zeigt der Unterpunkt den passenden Rollen-Ordner.
 */

import { useEffect, useState } from "react";

import { ryfeApi } from "../api";
import { useRyfe } from "../RyfeContext";

import { RyfeFiles } from "./RyfeFiles";

import "./ryfe.scss";

const TITLE: Record<string, string> = {
  trash: "Papierkorb",
  archive: "Archiv",
};

export const RyfeRoleFolderView = ({ role }: { role: "trash" | "archive" }) => {
  const { workspace, group } = useRyfe();
  const [folderId, setFolderId] = useState<string | null>(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    if (!workspace) {
      return;
    }
    let cancelled = false;
    const resolve = async () => {
      try {
        // Nearest scope wins: an active group → its own role folder (child of
        // its Teams folder); otherwise the workspace-level role folder.
        const listing =
          group && group.team_folder_id
            ? await ryfeApi.listFolder(workspace.id, group.team_folder_id)
            : await ryfeApi.getRoot(workspace.id);
        const hit = listing.folders.find((f) => f.role === role);
        if (!cancelled) {
          if (hit) {
            setFolderId(hit.id);
            setMissing(false);
          } else {
            setMissing(true);
          }
        }
      } catch {
        if (!cancelled) {
          setMissing(true);
        }
      }
    };
    setFolderId(null);
    setMissing(false);
    resolve();
    return () => {
      cancelled = true;
    };
  }, [workspace, group, role]);

  if (missing) {
    return (
      <div className="ryfe-page">
        <h1 className="ryfe-page__title">{TITLE[role]}</h1>
        <p className="ryfe-muted" style={{ padding: 0 }}>
          Kein {TITLE[role]} für den aktiven Bereich gefunden.
        </p>
      </div>
    );
  }
  if (!folderId) {
    return <div className="ryfe-muted">Lädt…</div>;
  }
  // Re-key on the resolved folder so a scope switch remounts the browser.
  return <RyfeFiles key={folderId} folderId={folderId} />;
};
